import LRU from 'lru';

const options = {
  max: 500,
  maxAge: 1000 * 60 * 60,
};
const cache = LRU(options);
const set = (key, value) => cache.set(key, value);
const get = key => cache.get(key);
const reset = () => {
  cache.clear();
};

export default {
  set,
  get,
  reset,
};
